
export const SET_MESSAGE = 'data/info/SET_MESSAGE';
export const SET_OBJECT = 'data/info/SET_OBJECT';
export const SET_OBJECT_CREATE = 'data/info/SET_OBJECT_CREATE';
export const SET_OBJECT_CREATE_ATTR_VALUE = 'data/info/SET_OBJECT_CREATE_ATTR_VALUE';
export const SET_OBJECT_EDIT = 'data/info/SET_OBJECT_EDIT';
export const SET_OBJECT_EDIT_ATTR_VALUE = 'data/info/SET_OBJECT_EDIT_ATTR_VALUE';
export const SET_OBJECT_LIST = 'data/info/SET_OBJECT_LIST';
export const SET_TYPE = 'data/info/SET_TYPE';
export const UPDATE_OBJECT_EDIT = 'data/info/UPDATE_OBJECT_EDIT';

export default function getActions(dispatch) {
    return {
        setMessage: (message) => dispatch({
            type: SET_MESSAGE,
            message
        }),
        setObject: (object, sourceType) => dispatch({
            type: SET_OBJECT,
            object, sourceType
        }),
        setObjectCreate: (dataModelItem) => dispatch({
            type: SET_OBJECT_CREATE,
            dataModelItem
        }),
        setObjectCreateAttrValue: (attrName, value) => dispatch({
            type: SET_OBJECT_CREATE_ATTR_VALUE,
            attrName, value
        }),
        setObjectEdit: (object) => dispatch({
            type: SET_OBJECT_EDIT,
            object
        }),
        setObjectEditAttrValue: (attrName, value) => dispatch({
            type: SET_OBJECT_EDIT_ATTR_VALUE,
            attrName, value
        }),
        setObjectList: (objectList, finished, coordinates) => dispatch({
            type: SET_OBJECT_LIST,
            objectList, finished, coordinates
        }),
        setType: (panelType) => dispatch({
            type: SET_TYPE,
            panelType: panelType
        })
    };
}
